import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegTimesCircle } from "react-icons/fa";
import { UserRepository } from "../repositories/UserRepository";

export default function ConfirmRegistration() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const { token } = useParams();

  useEffect(() => {
    if (token) {
      handleConfirmRegistration();
    }
  }, [token]);

  const handleConfirmRegistration = () => {
    setLoading(true);
    setError(false);
    setSuccess(false);

    UserRepository.confirmRegistration(token)
      .then((response) => {
        setSuccess(true);
        setLoading(false);
      })
      .catch((error) => {
        setError(true);
        setLoading(false);
      });
  };

  return (
    <Box className="registration-container">
      <Container
        className="registration-container-inner"
        sx={{ marginTop: { md: "-150px", sm: "-150px" } }}
      >
        <Grid item xs={12} className="registration-logo-container">
          <Typography variant={"h6"} sx={{ color: "white" }}>
            Систем за електронско аплицирање за трајна и временска <br />
            измена на режим за сообраќај
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="h5" color={"white"}>
            <b>Потврда на регистрација</b>
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ mt: 3, p: 2 }}>
          {loading && (
            <>
              <CircularProgress sx={{ color: "white" }} />
              <p style={{ fontSize: "1.1em", color: "white" }}>
                Ве молиме почекајте...
              </p>
            </>
          )}
          {!loading && success && (
            <>
              <FaCheckCircle size={50} color="green" />
              <p style={{ fontSize: "1.5em", color: "white" }}>
                Профилот е успешно активиран. Можете да се најавите.
              </p>
              <p>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Најава
                </Button>
              </p>
            </>
          )}
          {!loading && error && (
            <>
              <FaRegTimesCircle size={50} color="red" />
              <p style={{ fontSize: "1.5em", color: "white" }}>
                Настана грешка при активирање на профилот. <br /> Ве молиме
                контактирајте го администраторот.
              </p>
            </>
          )}
        </Grid>
      </Container>
    </Box>
  );
}
